import type { TUseRequestUpdaterProps } from 'features/request/useRequest';
import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';
import type { ContractSubObjectCreateInput, UerCreateContractSubObjectMutation } from 'gql/graphql';

import { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { uerCreateContractSubObjectGql } from '../../workOrderQueries';

const requestId = 'uerCreateContractSubObject';

export const useUerCreateContractSubObject = (
    onSuccess: ((newObjectId?: number) => void) | undefined,
    contractId: number | undefined,
) => {
    const dispatch = useDispatch();

    const [uerCreateContractSubObjectReset] = useResetStoreData({ requestId });

    const onSuccessLocal = useCallback(
        (depsVars: TUseRequestUpdaterProps<UerCreateContractSubObjectMutation>) => {
            uerCreateContractSubObjectReset(undefined);
            onSuccess?.(depsVars?.payload?.uerCreateContractSubObject?.data?.id);
        },
        [onSuccess, uerCreateContractSubObjectReset],
    );

    const [
        uerCreateContractSubObjectData,
        uerCreateContractSubObjectStatus,
        uerCreateContractSubObjectError,
        uerCreateContractSubObjectRequest,
    ] = useRequest({
        requestId,
        query: uerCreateContractSubObjectGql,
        withEffect: false,
        dependenciesUpdater: onSuccessLocal,
    });

    const uerCreateContractSubObjectMakeRequest = useCallback(
        (input: ContractSubObjectCreateInput) => {
            // TODO: fix
            dispatch(uerCreateContractSubObjectRequest({ input, contractId }));
        },
        [contractId, dispatch, uerCreateContractSubObjectRequest],
    );

    useEffect(() => {
        uerCreateContractSubObjectReset(undefined);
    }, [uerCreateContractSubObjectReset]);

    return {
        uerCreateContractSubObjectData,
        uerCreateContractSubObjectStatus,
        uerCreateContractSubObjectError,
        uerCreateContractSubObjectMakeRequest,
    };
};
